import React from 'react';
import PropTypes from 'prop-types';

/**
 * BannerMobile.
 * Re-usable component for product packages.
 *
 * @author  Manny
 * @param   {String}    props.industryKey     Name of the industry.
 * @param   {Function}  props.onSelectPackage Handles onClick for selecting a package.
 * @param   {String}    props.packageKey      Name of the package.
 * @param   {Object}    props.packages        List of packages.
 * @param   {String}    props.product         Name of the product.
 * @returns {JSX.Element} The component markup.
 */

const BannerMobile = ({ industryKey, onSelectPackage, packageKey, packages, product }) => {
  if (packages) {
    let classNames = require('classnames');
    let selectBtnClass = classNames({
      'btn btn-primary  margin-top-40':
        (packages[packageKey].popular || packages[packageKey].starburst) &&
        product !== 'commercial',
      'btn btn-primary  margin-top-25':
        !packages[packageKey].popular &&
        !packages[packageKey].starburst &&
        product !== 'commercial',
      'btn btn-primary ': product === 'commercial'
    });

    return (
      <div className='row no-margin mobile-package-selection'>
        <div className='col-xs-8 text-left'>
          {packages[packageKey].starburst === true && (
            <div className='margin-bottom-5'>
              <span className='popular-tag-mobile'>
                <i className='fa fa-star' aria-hidden='true'></i>
                <span> 20% Off</span>
              </span>
            </div>
          )}
          <p className='red-text text-uppercase no-margin heading3 mobile-package-title'>{packages[packageKey].title}</p>
          {packages[packageKey].dollars > 0 && (
            <p className='no-margin'>
              <span className='heading1'>
                {product === 'cordellEstimator' && <span>From </span>}$
                <b>{packages[packageKey].dollars}.{packages[packageKey].cents != '00' ? packages[packageKey].cents : ''}</b>
              </span>
              <span className='per-month captions'>/MTH</span>
            </p>
          )}
          {packages[packageKey].dollars === 0 && (
            <p className='no-margin'>
              <span className='heading1'>FREE</span>
            </p>
          )}
          <p className='footnote-text'>{packages[packageKey].sub_text_1}</p>
          {packages[packageKey].sub_text_2 !== '' && (
            <p className='footnote-text'>{packages[packageKey].sub_text_2}</p>
          )}
        </div>
        <div className='col-xs-4 text-right'>
          <button
            type='button'
            className={selectBtnClass}
            onClick={() => {
              onSelectPackage(industryKey, packageKey);
            }}
          >
            Select
          </button>
        </div>
      </div>
    );
  } else {
    return (
      <div className='row spinner'>
        <i className='fa fa-spinner fa-pulse fa-3x fa-fw'></i>
        <span className='sr-only'>Loading...</span>
      </div>
    );
  }
};

BannerMobile.propTypes = {
  industryKey: PropTypes.string,
  onSelectPackage: PropTypes.func.isRequired,
  packageKey: PropTypes.string,
  packages: PropTypes.object,
  product: PropTypes.string.isRequired
};

export default BannerMobile;
